export const SIZE_MAP = {
  "0": "0.8125rem",
  "1": "0.874rem",
  "2": "var(--tgph-spacing-4)",
  "3": "1.125rem",
  "4": "var(--tgph-spacing-5)",
  "5": "1.375rem",
  "6": "1.625rem",
  "7": "var(--tgph-spacing-8)",
  "8": "var(--tgph-spacing-9)",
  "9": "var(--tgph-spacing-12)",
} as const;

export const COLOR_MAP = {
  primary: {
    default: "var(--tgph-gray-12)",
    gray: "var(--tgph-gray-11)",
    accent: "var(--tgph-accent-11)",
    beige: "var(--tgph-beige-11)",
    blue: "var(--tgph-blue-11)",
    green: "var(--tgph-green-11)",
    yellow: "var(--tgph-yellow-11)",
    purple: "var(--tgph-purple-11)",
    red: "var(--tgph-red-11)",
    white: "var(--tgph-white)",
    disabled: "var(--tgph-gray-9)",
    black: "var(--tgph-black)",
  },
  secondary: {
    default: "var(--tgph-gray-11)",
    gray: "var(--tgph-gray-10)",
    accent: "var(--tgph-accent-10)",
    beige: "var(--tgph-beige-10)",
    blue: "var(--tgph-blue-10)",
    green: "var(--tgph-green-10)",
    yellow: "var(--tgph-yellow-10)",
    purple: "var(--tgph-purple-10)",
    red: "var(--tgph-red-10)",
    white: "var(--tgph-white)",
    disabled: "var(--tgph-gray-8)",
    black: "var(--tgph-black)",
  },
} as const;
